import React from "react";
const IconPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M4 10h12m-6 6V4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconPlus;
